<template>
  <div class="addBrake">
    <div class="top"></div>
    <div class="content">
      <div class="title">报损信息</div>
      <div class="cont" v-if="bale==2 || bale==3">
        <span>报损量</span>
        <input
          type="number"
          placeholder="请输入预估报损量"
          v-model="subData.num"
          style="padding-right:0.2rem;"
        />
        <span class="unit">公斤</span>
      </div>
      <div class="cont" v-if="bale==1 || bale==2">
        <span>报损定装数</span>
        <input
          type="number"
          placeholder="请输入预估报损定装数"
          v-model="subData.number"
          style="padding-right:0.2rem;"
        />
        <span class="unit" v-if="bale!=3 && num_unit==1">件</span>
        <span class="unit" v-if="bale!=3 && num_unit==2">包</span>
        <span class="unit" v-if="bale!=3 && num_unit==3">袋</span>
        <span class="unit" v-if="bale!=3 && num_unit==4">盒</span>
        <span class="unit" v-if="bale!=3 && num_unit==5">瓶</span>
        <span class="unit" v-if="bale!=3 && num_unit==6">箱</span>
        <span class="unit" v-if="bale!=3 && num_unit==7">罐</span>
      </div>
      <!-- <div class="cont">
        <span>报损金额</span>
        <input type="number" placeholder="请输入预估金额" v-model="subData.money" style="padding-right:0.2rem;">
        <span> 元</span>
      </div>-->
      <div class="bottom" @click="save">保存</div>
    </div>
  </div>
</template>

<script>
import { isEmpty, isMobile } from "@/utils/validate";
import {
  damaged_batch,
  damaged_add,
  damaged_del
} from "@/api/work/manage/stock";
export default {
  name: "addBrake",
  data() {
    return {
      subData: {
        batch: "",
        num: "",
        money: "",
        number: ""
      },
      bale: "",
      num_unit:""
    };
  },
  created() {
    console.log("==this.$route.query=", this.$route.query);
    this.subData.batch = this.$route.query.batch;
    this.bale = this.$route.query.bale;
    this.num_unit=this.$route.query.num_unit
  },
  mounted() {},
  methods: {
    // 保存数据
    save() {
      if (this.bale == 3 && !(this.subData.num > 0)) {
        this.$toast("请输入预估报损量！");
        return false;
      } else if (this.bale == 1 && !this.subData.number) {
        this.$toast("请输入预估报损箱数！");
        return false;
      } else if (this.bale == 2) {
        if (!this.subData.number && !this.subData.num) {
          this.$toast("请至少输入一种报损规格！");
          return false;
        }
      }
      damaged_add(this.subData).then(res => {
        this.$toast.success(res.message);
        this.$router.go(-1);
      });
    }
  }
};
</script>

<style lang="less" scoped>
.addBrake {
  .top {
    width: 100%;
    height: 3.6rem;
    background: url("../../../../assets/img/work/manage/buyer_bg.png") no-repeat
      center;
    background-size: 100% 100%;
  }
  .content {
    width: 6.5rem;
    margin: -1.8rem auto 0.78rem;
    background-color: #fff;
    padding: 0 0.3rem 0.3rem;
    border-radius: 0.16rem;

    overflow: hidden;
    .title {
      color: #727272;
      font-size: 0.24rem;
      margin-top: 0.44rem;
      margin-bottom: 0.09rem;
    }

    .cont {
      color: #343434;
      display: flex;
      align-items: center;
      font-size: 0.32rem;
      border-bottom: #e8e8e8 solid 0.01rem;
      margin-top: 0.4rem;
      padding-bottom: 0.19rem;
      input {
        flex-grow: 1;
        flex-shrink: 0;
      }
      > span:first-child {
        display: inline-block;
        width: 1.64rem;
        margin-right: 0.06rem;
      }
      .unit {
        white-space: nowrap;
      }
    }
    .text {
      margin: 0.2rem auto 1.07rem;
      > div {
        width: 6.49rem;
        height: 3.26rem;
        border: 0.01rem #e4e4e4 solid;
      }
    }
    .bottom {
      width: 6.5rem;
      line-height: 1rem;
      background-color: #31b158;
      text-align: center;
      color: #fff;
      border-radius: 0.08rem;
      margin-top: 0.8rem;
      font-size: 0.36rem;
    }
  }
}
</style>